// Configuração centralizada de níveis de log por domínio
export const loggerConfig = {
  // Domínios de desenvolvimento
  'devscherer.srssistemas.com': {
    production: 'info',
    development: 'debug',
  },
  // Domínios de produção
  'scherer-sa.com.br': {
    production: 'warn',
    development: 'debug',
  },
  // Configuração padrão (fallback)
  default: {
    production: 'info',
    development: 'debug',
  },
}

// Função auxiliar para obter o nível de log baseado no hostname
export function getLogLevelByHostname () {
  const isProduction = process.env.NODE_ENV === 'production'
  const env = isProduction ? 'production' : 'development'

  // Verifica se está rodando no browser
  if (typeof window === 'undefined') {
    return loggerConfig.default[env]
  }

  const hostname = window.location.hostname

  // Procura por correspondência parcial no hostname
  for (const [domain, levels] of Object.entries(loggerConfig)) {
    if (domain !== 'default' && hostname.includes(domain)) {
      return levels[env]
    }
  }

  // Retorna configuração padrão
  return loggerConfig.default[env]
}
